import { HttpStatusCode, isAxiosError } from 'axios'

import { type ErrorResponse, type UserMeExEntity, apiClient } from '@/libs/api'
import { ErrorType } from '@/libs/api/interceptors'

export const fetchMe = async (): Promise<UserMeExEntity | null> => {
  try {
    const { data } = await apiClient.users.me.$get()
    return data
  } catch (e) {
    if (isForbiddenUser(e)) {
      // アクセス権がない場合は 403 ページへ飛ばしたいので再スローする
      // ここで null を返すとログイン画面へのリダイレクトが発生するため
      throw e
    }
  }
  return null
}

const isForbiddenUser = (error: unknown): boolean => {
  if (isAxiosError(error)) {
    if (error.response?.status === HttpStatusCode.Forbidden) {
      const response = error.response?.data as ErrorResponse
      if (
        response?.type === ErrorType.FORBIDDEN_NOT_IN_LOGIGO_USER_GROUP ||
        response?.type === ErrorType.FORBIDDEN_DISABLED_USER
      ) {
        return true
      }
    }
  }
  return false
}
